export default "__VITE_ASSET__83be41c2__"